<template>
  <div data-grm-comp="StopWatch"
      class="room-stopwatch-component" :data-user-relax="isRelax" :data-stopwatch-type="selectedStopwatchType" :data-pomodoro-type="selectedStopwatchSubType"
      :data-me="me" :data-stopwatch-state="stopwatchState"
  >
    <div class="timer-item stopwatch-basic stopwatch-time" :class="selectedStopwatchSubType" v-if="selectedStopwatchType==='basic'">{{formatTime}}</div>
    <div class="timer-item stopwatch-pomodoro" :class="pomodoroType" v-if="!isRelax && selectedStopwatchType==='pomodoro'">
      <div class="stopwatch-pomodoro-rect" v-if="selectedStopwatchSubType==='pomodoro_rect'">
        <div class="pomodoro-bg square-bg">
          <div class="square-bar">
            <div class="progress-bar" :style="pomodoroBarWidthStr"></div>
          </div>
        </div>
        <div class="pomodoro-time-tx">
          <div class="count-time">{{pomodoroTimeStr}} 22</div>
          <div class="cumulative-time stopwatch-time">{{formatTime}} 33</div>
        </div>
      </div>
      <div class="stopwatch-pomodoro-circle" v-if="selectedStopwatchSubType==='pomodoro_circle'">
        <div class="pomodoro-bg circle-bg">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
            <circle id="circle"
                    cx="0"
                    cy="0"
                    r="42"
                    :style="pomodoroCircleWidthStr"
                    stroke-dasharray="430"
                    stroke-width="4px"
                    stroke="#51a9fe"
                    fill="transparent"
                    transform="translate(44,44) rotate(-90)"
            />
          </svg>
        </div>
        <div class="pomodoro-time-tx">
          <div class="count-time">{{pomodoroTimeStr}}</div>
          <div class="cumulative-time stopwatch-time">{{formatTime}}</div>
        </div>
      </div>
      <div class="stopwatch-pomodoro-mobile" v-if="selectedStopwatchSubType==='pomodoro_mobile'">
        <div class="pomodoro-bg square-bg">
          <div class="square-bar">
            <div class="progress-bar" :style="pomodoroBarWidthStr"></div>
          </div>
        </div>
        <div class="pomodoro-time-tx">
          <div class="count-time">{{pomodoroTimeStr}}</div>
          <div class="cumulative-time stopwatch-time">{{formatTime}}</div>
        </div>
      </div>
    </div>
    <div class="timer-item stopwatch-cash-set-01" :data-timer-type="selectedStopwatchSubType" v-if="selectedStopwatchType === 'cash-item-01'">
      <div class="room-stopwatch-shape">
        <div class="room-stopwatch-shape-tx stopwatch-shape-time">{{formatTime}}</div>
      </div>
    </div>
<!--    <div class="stopwatch-control-btns" v-if="!isRelax">-->
<!--      <button class="stopwatch-controls-pause" data-btn="stopwatch-pause" @click.stop="toggleStopwatch" ref="pause"></button>-->
<!--      <button class="stopwatch-controls-reset" data-btn="stopwatch-reset" @click.stop="reqResetStopwatch" ref="reset">-->
<!--        <div class="stopwatch-controls-reset-obj"></div>-->
<!--      </button>-->
<!--      <transition name="stopwatch-toast">-->
<!--        <div class="stopwatch-control-guide-tx" v-if="isShowGuide">일시정지하려면<br>스탑워치를 누르세요</div>-->
<!--      </transition>-->
<!--    </div>-->
<!--    <div class="stopwatch-relax-wrapper" v-show="studyState==='relax' && selectedStopwatchType==='pomodoro'">-->
<!--      <span class="stopwatch-relax-title-tx">휴식 시간</span>-->
<!--      <span class="stopwatch-relax-time-tx">{{ relaxTimeStr }}</span>-->
<!--      <button v-if="me" class="stopwatch-relax-exit-btn" @click.stop="handleRelaxOff">휴식 종료</button>-->
<!--    </div>-->
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'StopWatch',
  components: {},
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      csUser: {},
      studyState: 'pause',
      isRelax: false,
      time: 0,
      pomodoroTimeStr: '00:00',
      relaxTimeStr: '00:00',
      pomodoroTimeSetting: '1',
      relaxTimeSetting: '1',
      pomodoroCircleWidth: 100,
      isFocusOfNoti: false,
      isRelaxOfNoti: true,
      userCameraSetting: '',
      isShowGuide: false,
      toggleDebounce: null,
      modal: null,
    }
  },
  watch: {
    lowPowerMode: {
      handler(level){
        this.setLowPowerMode();
      },
      immediate: true,
    }
  },
  mounted() {
    this.setLowPowerMode();
  },
  computed: {
    ...mapGetters('user', ['isMe']),
    ...mapGetters('camstudy', ['getUserStopwatch', 'getCamStudyUser', 'getUserStudyData']),
    ...mapGetters('room', ['lowPowerMode']),
    me() {
      return this.isMe(this.user?.userId)
    },
    stopwatch() {
      return this.getUserStopwatch(this.user?.userId)
    },
    stopwatchState() {
      return this.stopwatch?.state || 'pause'
    },
    formatTime() {
      const seconds = this.stopwatch?.time || 0
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      const paddedHours = hours.toString().padStart(2, '0');
      const paddedMinutes = minutes.toString().padStart(2, '0');
      const paddedSeconds = secs.toString().padStart(2, '0');

      return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
    },
    userStopWatchSetting() {
      const camStudyUser = this.getCamStudyUser(this.user?.userId);
      return camStudyUser?.camStudyUserItemSettingList?.[0]?.itemSetting;
    },
    selectedStopwatchType() {
      return this.userStopWatchSetting?.selectedStopwatchType || 'basic';
    },
    selectedStopwatchSubType() {
      return this.userStopWatchSetting?.selectedStopwatchSubType || 'default';
    }
  },
  methods: {
    ...mapActions('camstudy', ['changeStopwatchState', 'resetStopwatch', 'createTodayCamStudyUserData']),
    setLowPowerMode () {
      let term = 600;
      if(!this.$el){
        return;
      }
      if(this.lowPowerMode > 0){
        this.$el.style.opacity = 0;
        setTimeout(() => {
          if(!this.$el.classList.contains('lowPowerMode')){
            this.$el.classList.add('lowPowerMode');
          }
          this.$el.style.opacity = 1;
        }, term);
      }else{
        this.$el.style.opacity = 0;
        setTimeout(() => {
          this.$el.classList.remove('lowPowerMode');
          this.$el.style.opacity = 1;
        }, term);
      }
    },
    toggleStopwatch() {
      if(!this.me) return
      const studyData = this.getUserStudyData(this.me.userId)
      if(!studyData) {
        this.$camsAlert({
          title: this.$t('camstudy.stopwatch.attendance.title'),
          text: this.$t('camstudy.stopwatch.attendance.text'),
          ok: () => {
            this.createTodayCamStudyUserData()
          }
        })
        return
      }
      clearTimeout(this._toggleDebounce)
      this._toggleDebounce = setTimeout(() => {
        this.changeStopwatchState(this.stopwatchState !== 'start' ? 'start' : 'pause')
      }, 200)
    },
    reqResetStopwatch() {
      if(!this.me) return
      this.$camsAlert({
        title: this.$t('camstudy.stopwatch.reset.title'),
        text: this.$t('camstudy.stopwatch.reset.text'),
        ok: () => {
          this.resetStopwatch()
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.mobile .stopwatch-relax-time-tx {
  font-size: 16px;
}
.mobile [data-stopwatch-state='relax'] .my-msg {
  display: none;
}
.timer-item {
  display: none;
}
//.stopwatch-basic,
.pomodoro-bg {
  transition: 200ms ease-out;
}
[data-stopwatch-type][data-stopwatch-type="basic"] .stopwatch-basic {
  display: block;
}
[data-stopwatch-type][data-stopwatch-type="pomodoro"] .stopwatch-pomodoro {
  display: block;
}
[data-stopwatch-type][data-pomodoro-type="pomodoro_rect"] .pomodoro-time-tx {
  justify-content: space-between;
  align-items: center;
  padding: 12px 12px 18px;
}
[data-stopwatch-type][data-pomodoro-type="pomodoro_circle"] {
  top: 10px;
  right: 10px;
}
[data-stopwatch-type][data-pomodoro-type="pomodoro_circle"] .circle-bg {
  display: block;
}
[data-stopwatch-type][data-pomodoro-type="pomodoro_circle"] .pomodoro-time-tx {
  flex-direction: column;
  padding: 8px;
  justify-content: center;
  text-align: center;
}
[data-stopwatch-type][data-pomodoro-type="pomodoro_circle"] .pomodoro-time-tx .count-time {
  margin-bottom: 6px;
}
[data-stopwatch-type][data-pomodoro-type="pomodoro_mobile"] .square-bg {
  display: block;
  width: 100%;
  height: 36px;
  background-color: rgba(0, 0, 0, 0.5);
}
[data-stopwatch-type][data-pomodoro-type="pomodoro_mobile"] .square-bg .square-bar {
  top: 0;
  height: auto;
  background: none;
}
[data-stopwatch-type][data-pomodoro-type="pomodoro_mobile"] .pomodoro-time-tx {
  justify-content: space-between;
  align-items: center;
  padding: 0 14px;
}
[data-stopwatch-type][data-stopwatch-type="cash-item-01"] .stopwatch-cash-set-01 {
  display: block;
}
.stopwatch-relax-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: #102132;
  z-index: 3;
}
.stopwatch-relax-title-tx {
  font-size: 14px;
  font-weight: bold;
}
.stopwatch-relax-time-tx {
  margin-top: 8px;
  font-size: 56px;
}
.stopwatch-relax-exit-btn {
  position: absolute;
  right: 10px;
  bottom: 10px;
  color: white;
  width: 56px;
  height: 56px;
  border-radius: 100%;
  background-color: rgba(255, 255, 255, 0.3);
  font-size: 13px;
  line-height: 1.2;
  pointer-events: auto;
}
.stopwatch-relax-exit-btn:hover,
.stopwatch-relax-exit-btn:active {
  background-color: #1f90ff;
}
/**

 */
.cordi-stopWatch {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 4;
}
.cordi-stopWatch[data-pomodoro-type="pomodoro_mobile"] {
  left: 0;
}
.timer-item {
  position: relative;
}
.stopwatch-basic {
  position: relative;
  height: 24px;
  border-radius: 6px;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  color: white;
  line-height: 24px;

  &.default {
    background-color: rgba(0, 0, 0, 0.7);
  }

  &.color-italic {
    background-color: rgba(0, 90, 180, 0.7);
    font-style: italic;
  }
}

.stopwatch-pomodoro .square-bg {
  width: 140px;
  height: 48px;
  background-color: rgba(0, 0, 0, 0.7);
}

.stopwatch-pomodoro .square-bg .square-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 6px;
  background-color: rgba(255, 255, 255, 0.2);
}
.stopwatch-pomodoro .square-bg .square-bar .progress-bar {
  position: relative;
  background-color: #51a9fe;
  height: 100%;
  transition: 120ms ease-out;
  opacity: 0.9;
}
.stopwatch-pomodoro .circle-bg {
  width: 88px;
  height: 88px;
  border-radius: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
.stopwatch-pomodoro .circle-bg > svg {
  width: 100%;
  height: 100%;
}
.stopwatch-pomodoro .circle-bg > svg circle {
  transition: 120ms ease-out;
}
.stopwatch-pomodoro .pomodoro-time-tx {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  user-select: none;
}
.stopwatch-pomodoro .pomodoro-time-tx .count-time {
  font-size: 20px;
  font-weight: bold;
  color: white;
  letter-spacing: 0.2;
  transition: 120ms ease-out;
}
.stopwatch-pomodoro .pomodoro-time-tx .cumulative-time {
  font-size: 12px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 0.2;
}
.stopwatch-pomodoro .pomodoro-time-tx:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  background: #f05 url('~@/assets/images/camstudy/ico_pause_white.svg') center no-repeat;
  background-size: auto 48%;
  transition: 200ms ease-out;
  transform: scale(0);
}
.stopwatch-cash-set-01[data-timer-type="1"] .room-stopwatch-shape {
  background: url("~@/assets/images/camstudy/stopwatch_background_image1.svg") top right no-repeat;
  background-size: 100% auto;
}
.stopwatch-cash-set-01[data-timer-type="2"] .room-stopwatch-shape {
  background: url("~@/assets/images/camstudy/stopwatch_background_image2.svg") top right no-repeat;
  background-size: 100% auto;
}
.stopwatch-cash-set-01[data-timer-type="3"] .room-stopwatch-shape {
  background: url("~@/assets/images/camstudy/stopwatch_background_image3.svg") top right no-repeat;
  background-size: 100% auto;
}
.stopwatch-cash-set-01[data-timer-type="4"] .room-stopwatch-shape {
  background: url("~@/assets/images/camstudy/stopwatch_background_image4.svg") top right no-repeat;
  background-size: 100% auto;
}
.stopwatch-cash-set-01[data-timer-type="5"] .room-stopwatch-shape {
  background: url("~@/assets/images/camstudy/stopwatch_background_image5.svg") top right no-repeat;
  background-size: 100% auto;
}
.stopwatch-cash-set-01[data-timer-type="6"] .room-stopwatch-shape {
  background: url("~@/assets/images/camstudy/stopwatch_background_image6.svg") top right no-repeat;
  background-size: 100% auto;
}
.cordi-stopwatch-shape {
  position: relative;
  width: 140px;
  height: 40px;
}
.cordi-stopwatch-shape .stopwatch-shape-bg {
  width: 100%;
  height: 100%;
}
.cordi-stopwatch-shape .stopwatch-shape-tx {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  font-size: 18px;
  color: white;
  letter-spacing: 0.2;
  line-height: 40px;
}
.room-stopwatch-shape {
  position: relative;
  width: 80px;
  height: 28px;
}
.room-stopwatch-shape-bg-wrapper {
  opacity: 0.9;
}
.room-stopwatch-shape-bg {
  display: none;
  width: 100%;
  height: 100%;
}
.room-stopwatch-shape-bg.shape-01 {
  fill: #ff9423;
}
.room-stopwatch-shape-bg.shape-02 {
  border-radius: 0 0 0 24px;
  background-color: #3561DE;
}
.room-stopwatch-shape-bg.shape-03 {
  fill: #f3c01e;
}
.room-stopwatch-shape-bg.shape-04 {
  fill: #A171F5;
}
.room-stopwatch-shape-bg.shape-05 {
  border-radius: 0 0 24px 24px;
  background-color: #ACB840;
}
.room-stopwatch-shape-bg.shape-06 {
  background-color: #ED74A5;
}
.room-stopwatch-shape-tx {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: white;
  line-height: 20px;
  //transition: 120ms ease-out;
}
.stopwatch-tab-layer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 110px;
  border-radius: 10px 10px 0 0;
  background-color: white;
  z-index: 5;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.05);
  transition: 120ms ease-out;
}
.stopwatch-tab-layer.stopwatchSubModal {
  height: 60px;
}
.stopwatch-tab-layer.stopwatchSubModal .stopwatch-menu-item-list {
  padding: 0 10px;
}
.stopwatch-tab-layer.stopwatchSubModal .stopwatch-menu-item {
  padding: 0;
}
.stopwatch-tab-layer.stopwatchSubModal .stopwatch-menu-tx {
  margin: 0;
  font-size: 14px;
  line-height: 60px;
}
.stopwatch-menu-item-list {
  display: flex;
  justify-content: space-between;
  height: 100%;
  padding: 10px;
  transition: 200ms ease-out;
}
.stopwatch-menu-item {
  flex: 1;
  padding: 15px 0 20px;
  cursor: pointer;
}
.stopwatch-menu-item.selected {
  font-weight: bold;
}
.stopwatch-menu-tx {
  display: block;
  font-size: 13px;
  margin-bottom: 10px;
  color: #3e4345;
}
.stopwatch-menu-img {
  width: 100%;
  height: 32px;
}
.stopwatch-menu-img.basic {
  background: url('~@/assets/images/camstudy/stopwatch_menu_basic.svg') center no-repeat;
  background-size: auto;
}
.stopwatch-menu-img.cash-item-01 {
  background: url('~@/assets/images/camstudy/stopwatch_menu_cash.svg') center no-repeat;
  background-size: auto;
}
.stopwatch-menu-img.pomodoro {
  background: url('~@/assets/images/camstudy/stopwatch_menu_pomodoro.svg') center no-repeat;
  background-size: auto;
}
.stopwatch-enter-active,
.stopwatch-leave-active {
  transition: 200ms ease-out;
}
.stopwatch-enter.settings,
.stopwatch-leave-to.settings {
  bottom: -110px;
}
.stopwatch-enter.basic,
.stopwatch-leave-to.basic {
  bottom: -110px;
}
.stopwatch-enter.cash,
.stopwatch-leave-to.cash {
  bottom: -156px;
}
.stopwatch-enter.pomodoro,
.stopwatch-leave-to.pomodoro {
  bottom: -260px;
}
.stopwatch-tab-sub-layer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f3f6f7;
  overflow-y: auto;
  box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.4);
  z-index: 4;
}
.stopwatch-tab-sub-layer.basic {
  height: 170px;
}
.stopwatch-tab-sub-layer.pomodoro {
  height: 290px;
}
.stopwatch-tab-sub-layer.cash {
  height: 280px;
}
.stopwatch-pomodoro-wrapper {
  padding-bottom: 90px;
}
.stopwatch-basic-item-list {
  display: flex;
  flex-wrap: wrap;
  padding: 30px;
}
.stopwatch-basic-item {
  position: relative;
  width: 48%;
  margin-left: 4%;
}
.stopwatch-basic-item:first-child {
  margin: 0;
}
.stopwatch-basic-item-img {
  height: 48px;
  padding: 0 20px;
  border-radius: 6px;
  font-size: 18px;
  font-weight: 500;
  color: white;
  letter-spacing: 0.4;
  line-height: 48px;
}
.stopwatch-basic-item-img.default {
  background-color: rgba(0, 0, 0, 0.7);
}
.stopwatch-basic-item-img.color-italic {
  background-color: #005ab4;
  font-style: italic;
}
.stopwatch-basic-item-checked {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: #1f90ff url("~@/assets/images/camstudy/ico_check_white.svg") center no-repeat;
  background-size: auto 40%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.stopwatch-basic-item-checked.selected {
  display: block;
}
.stopwatch-cash-item-list {
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  padding: 24px 20px 90px;
}
.stopwatch-cash-item {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 80px;
  background-color: white;
  margin-bottom: 1px;
  border-radius: 4px;
  box-sizing: border-box;
}
.stopwatch-cash-item.odd {
  width: calc(50% - 1px);
  margin-right: 1px;
}
.stopwatch-cash-item:after {
  display: none;
  content: '';
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: #1f90ff url("~@/assets/images/camstudy/ico_check_white.svg") center no-repeat;
  background-size: auto 40%;
}
.stopwatch-cash-item.selected {
  border: 2px solid #1f90ff;
}
.stopwatch-cash-item.selected:after {
  display: block;
}
.stop-watch-cash-img {
  width: 116px;
  height: 36px;
}
.stop-watch-cash-img[data-timer-type="1"] {
  background: url("~@/assets/images/camstudy/stopwatch_yellow.svg") center no-repeat;
  background-size: auto;
}
.stop-watch-cash-img[data-timer-type="2"] {
  background: url("~@/assets/images/camstudy/stopwatch_blue.svg") center no-repeat;
  background-size: auto;
}
.stop-watch-cash-img[data-timer-type="3"] {
  background: url("~@/assets/images/camstudy/stopwatch_green.svg") center no-repeat;
  background-size: auto;
}
.stop-watch-cash-img[data-timer-type="4"] {
  background: url("~@/assets/images/camstudy/stopwatch_puple.svg") center no-repeat;
  background-size: auto;
}
.stop-watch-cash-img[data-timer-type="5"] {
  background: url("~@/assets/images/camstudy/stopwatch_blueGreen.svg") center no-repeat;
  background-size: auto;
}
.stop-watch-cash-img[data-timer-type="6"] {
  background: url("~@/assets/images/camstudy/stopwatch_pink.svg") center no-repeat;
  background-size: auto;
}
.stop-watch-cash-tx {
  display: block;
  text-align: center;
  font-size: 14px;
  color: white;
  letter-spacing: 0.4px;
  line-height: 36px;
}
.stopwatch-content-column {
  text-align: left;
}
.stopwatch-content-column-title {
  display: block;
  font-size: 12px;
  font-weight: bold;
  color: #aaa;
}
.stopwatch-content-alert-tx {
  color: #ff005a;
  font-weight: normal;
}
.stopwatch-content-row {
  display: flex;
  background-color: white;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding: 0 20px;
  border-bottom: 1px solid #d6dee1;
  box-sizing: border-box;
  position: relative;
}
.stopwatch-content-row.label {
  height: auto;
  padding: 28px 20px 10px;
  background: none;
  border: none;
}
.stopwatch-content-row input[type="checkbox"].toggleBtn {
  display: block;
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  width: 50px;
  height: 30px;
  border-radius: 15px;
  background-color: #ddd;
  cursor: inherit;
  transition: all 300ms ease-out;
}
.stopwatch-content-row input[type="checkbox"].toggleBtn::after {
  content: '';
  position: absolute;
  top: 1px;
  left: 1px;
  width: 28px;
  height: 28px;
  border-radius: 100%;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  transition: all 200ms ease-out;
}
.stopwatch-content-row input[type="checkbox"].toggleBtn:checked {
  background-color: #51a9fe;
}
.stopwatch-content-row input[type="checkbox"].toggleBtn:checked:after {
  left: 21px;
}
.stopwatch-content-row:last-child {
  border: none;
}
.stopwatch-content-row .stopwatch-content-time-set-pc-type {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.stopwatch-content-row .stopwatch-content-time-setting {
  display: flex;
  align-items: center;
}
.stopwatch-content-row .stopwatch-content-time-select {
  position: relative;
}
.stopwatch-content-row .stopwatch-content-time-select > select {
  display: block;
  position: relative;
  width: 100px;
  height: 30px;
  padding: 0 12px;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.stopwatch-content-row .stopwatch-content-time-select > select.userInput {
  border-radius: 4px 0 0 4px;
}
.stopwatch-content-row .stopwatch-content-time-select:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 30px;
  background: url('~@/assets/images/camstudy/ico_arrowTriangleDown.svg') center no-repeat;
  background-size: auto 20%;
  pointer-events: none;
}
.stopwatch-content-row .stopwatch-content-row-selectInput {
  width: 72px;
  height: 30px;
  margin: 0;
  padding: 0 12px;
  border-radius: 0 4px 4px 0;
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  border-left: none;
  text-align: right;
}
.stopwatch-content-row .stopwatch-content-row-selectInput:focus {
  background-color: white;
  border-color: #1f90ff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.stopwatch-content-row .stopwatch-content-row-selectInput.isValid {
  border-color: #ff005a;
}
.stopwatch-content-row .stopwatch-content-input-tx {
  margin-left: 10px;
  font-size: 14px;
}
.stopwatch-content-btn {
  width: 100%;
  height: 100%;
  display: none;
  justify-content: space-between;
}
.stopwatch-content-row-title {
  display: block;
  font-size: 16px;
  color: #3e4345;
}
.stopwatch-content-row-selectBtn {
  display: block;
  font-size: 16px;
  font-weight: bold;
  color: #3e4345;
  padding-right: 24px;
  background: url("~@/assets/images/camstudy/ico_arrowLineRight.svg") top 1px right no-repeat;
  background-size: auto 70%;
}
.stopwatch-pomodoro-item-list {
  display: flex;
  flex-wrap: wrap;
  padding: 24px;
  align-items: center;
  background-color: white;
}
.stopwatch-pomodoro-item {
  flex: 1;
  position: relative;
  box-sizing: border-box;
  border-radius: 4px;
  border: 2px solid transparent;
}
.stopwatch-pomodoro-item:after {
  display: none;
  content: '';
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: #1f90ff url("~@/assets/images/camstudy/ico_check_white.svg") center no-repeat;
  background-size: auto 40%;
}
.stopwatch-pomodoro-item.selected {
  background-color: white;
  border-color: #1f90ff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.stopwatch-pomodoro-item.selected:after {
  display: block;
}
.stopwatch-pomodoro-item.selected .stopwatch-pomodoro-item-tx {
  color: #222;
}
.stopwatch-pomodoro-item-btn {
  padding: 0 20px 20px;
}
.stopwatch-pomodoro-item-btn.pomodoro_rect .stopwatch-pomodoro-item-img {
  background: url("~@/assets/images/camstudy/stopwatch_pomodoro_bar.svg") center no-repeat;
  background-size: auto 60%;
}
.stopwatch-pomodoro-item-btn.pomodoro_circle .stopwatch-pomodoro-item-img {
  background: url("~@/assets/images/camstudy/stopwatch_pomodoro_circle.svg") center no-repeat;
  background-size: auto 76%;
}
.stopwatch-pomodoro-item-btn.pomodoro_mobile .stopwatch-pomodoro-item-img {
  background: url("~@/assets/images/camstudy/stopwatch_pomodoro_mobile.svg") center no-repeat;
  background-size: auto 50%;
}
.stopwatch-pomodoro-item-img {
  height: 90px;
}
.stopwatch-pomodoro-item-tx {
  margin-top: 6px;
  text-align: center;
  font-size: 13px;
  color: #999;
}
.stopwatch-warn-tx {
  text-align: left;
  display: block;
  font-size: 13px;
  padding-left: 20px;
  background: url("~@/assets/images/camstudy/ico_info_darkgray.svg") center left no-repeat;
  opacity: 0.3;
  margin: 24px 0 0 24px;
}
.stopwatch-tab-full-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f3f6f7;
  z-index: 10;
  overflow: auto;
}
.stopwatch-settings-header {
  width: 100%;
  height: 52px;
  background-color: #ffffff;
  text-align: left;
  font-size: 16px;
}
.stopwatch-settings-divider {
  width: 100%;
  border-bottom: 14px solid #f3f6f7;
}
.stopwatch-settings-header-title {
  padding-left: 23px;
  background: url("~@/assets/images/camstudy/ico_arrowLineLeft.svg") center left no-repeat;
  background-size: auto 80%;
  line-height: 52px;
  margin-left: 17px;
}
.stopwatch-settings-list {
  background-color: #FFFFFF;
  padding-left: 20px;
}
.stopwatch-settings-item {
  height: 60px;
  border-bottom: 1px solid #d6dee1;
  text-align: left;
  line-height: 60px;
  box-sizing: border-box;
  position: relative;
}
.stopwatch-settings-item:last-child {
  border-bottom: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.stopwatch-settings-item-tx {
  font-size: 16px;
  color: #3e4345;
}
.stopwatch-settings-item-tx.min {
  font-weight: bold;
  padding-right: 23px;
  background: url("~@/assets/images/camstudy/ico_arrowLineRight.svg") center right no-repeat;
  background-size: auto 90%;
  margin-right: 24px;
}
.stopwatch-settings-info {
  display: block;
  font-size: 13px;
  text-align: left;
  padding-left: 20px;
  margin: 21px 0 0 22px;
  background: url("~@/assets/images/camstudy/ico_info_darkgray.svg") top left no-repeat;
  background-size: auto 40%;
  opacity: 0.3;
}
.stopwatch-settings-item-checked {
  display: none;
  width: 24px;
  height: 24px;
  position: absolute;
  right: 0;
  top: 0;
  margin: 20px 27px 0 0;
  background: url("~@/assets/images/camstudy/ico_check_blue.svg") center no-repeat;
  background-size: auto 80%;
}
.stopwatch-settings-item-checked.isChecked {
  display: block;
}
.stopwatch-settings-form {
  width: 100%;
  text-align: left;
}
.stopwatch-settings-input-title {
  display: block;
  text-align: left;
  font-size: 13px;
  color: #3e4345;
  padding: 11px 0 14px 20px;
}
.stopwatch-settings-input {
  width: 100%;
  height: 60px;
  padding-left: 20px;
  text-align: left !important;
}
/**********************************************/
/******************** Room ********************/
/**********************************************/
.room-stopwatch-component {
  position: absolute;
  top: 10px;
  right: 10px;
  pointer-events: auto;
  z-index: 2;
  transform-origin: right center;
  transition: opacity 0.6s;
  &.lowPowerMode{
    top: 5px;
    left: 5px;
    right: 5px;
    aspect-ratio: 1 / 1;
    opacity: 1;
    .timer-item{
      width: 100%;
      height: 100%;
      border-radius: 6px;
      background: rgba(0, 0, 0, 0.60) !important;

      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFF;
      font-size: 26px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
    }
  }

  &[data-stopwatch-type="cash-item-01"]{
    top: 5px;
    right: 5px;
    border-radius: 0 12px 0 0;
    overflow: hidden;
  }

  .stopwatch-basic {
    padding: 0 10px 0 10px;
  }

  &[data-stopwatch-state="pause"] {
    .room-stopwatch-component:before {
      background-color: #f05;
      animation: none;
    }

    .stopwatch-basic,.stopwatch-shape-time {
      
    }

    .stopwatch-controls-pause {
      width: calc(100% - 36px);
      padding-left: 36px;
      background: url('~@/assets/images/camstudy/ico_arrowTriangleRight_white.svg') 12px center no-repeat;
      background-size: auto 30%;
      font-size: 12px;
      font-weight: bold;
      color: transparent;
      opacity: 0.9;
      transition: 100ms ease-out;
    }

    .stopwatch-controls-pause:hover {
      background-size: auto 36%;
      font-size: 14px;
      color: white;
      opacity: 1;
    }

    .stopwatch-controls-reset {
      display: flex;
      pointer-events: auto;
    }

    .stopwatch-controls-reset .stopwatch-controls-reset-obj {
      transform: scale(1);
    }

    [data-pomodoro-type="pomodoro_circle"] {
      circle {
        stroke: rgba(255, 255, 255, 0.2);
      }

      .stopwatch-controls-pause {
        width: 100%;
        padding: 0;
        background-position-x: center;
        background-size: auto 30%;

        &:hover {
          padding-top: 30px;
          background-position-y: 20px;
          background-size: auto 24%;
        }
      }

      .stopwatch-controls-reset-obj {
        background: black url('~@/assets/images/camstudy/ico_reload_white.svg') center no-repeat;
        background-size: auto 70%;
      }

      .stopwatch-controls-reset:hover .stopwatch-controls-reset-obj {
        transform: scale(1.2) rotate(-270deg) !important;
      }
    }

    [data-pomodoro-type="pomodoro_mobile"] .stopwatch-controls-pause {
      width: calc(100% - 40px);
    }

    [data-stopwatch-type="cash-item-01"] .stopwatch-controls-pause {
      background-position-x: 16px;
    }
  }
}
//.room-stopwatch-component:before {
//  content: '';
//  position: absolute;
//  top: 16px;
//  left: 12px;
//  width: 8px;
//  height: 8px;
//  border-radius: 100%;
//  background-color: #4cce7e;
//  z-index: 1;
//}

.room-stopwatch-component .stopwatch-controls-pause {
  background-size: auto 48%;
}
.room-stopwatch-component[data-stopwatch-type="basic"] .pomodoro-time-tx {
  padding-left: 26px !important;
}
.room-stopwatch-component[data-stopwatch-type="basic"] .stopwatch-control-btns {
  border-radius: 6px;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_rect"] .square-bg {
  width: 160px;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_rect"] .stopwatch-controls-pause {
  height: 42px;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_rect"] .stopwatch-controls-reset {
  width: 36px;
  height: 42px;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_rect"] .pomodoro-time-tx {
  padding: 12px 12px 20px 28px;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_circle"]:before {
  display: none;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_circle"] .stopwatch-controls-pause {
  border-radius: 100%;
  background-position-y: 90px;
  background-size: auto 30%;
  overflow: hidden;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_circle"] .stopwatch-controls-reset {
  width: 24px;
  height: 24px;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_circle"] .pomodoro-time-tx {
  padding: 0 !important;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_circle"] .pomodoro-time-tx:before {
  display: none !important;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_mobile"] {
  left: 0;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_mobile"]:before {
  top: 14px;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_mobile"] .square-bg {
  width: 100%;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_mobile"] .pomodoro-time-tx {
  padding: 0 14px 0 28px;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_mobile"] .stopwatch-controls-reset {
  width: 40px;
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_mobile"] .stopwatch-control-guide-tx {
  right: calc(50% - 62px);
}
.room-stopwatch-component[data-pomodoro-type="pomodoro_mobile"] .stopwatch-control-guide-tx:after {
  right: calc(50% - 6px);
}
.room-stopwatch-component[data-stopwatch-type="cash-item-01"]:before {
  left: 16px;
}
.room-stopwatch-component[data-stopwatch-type="cash-item-01"]:hover .stopwatch-control-btns {
  background-color: transparent;
}
.room-stopwatch-component[data-stopwatch-type="cash-item-01"] .stopwatch-controls-reset {
  width: 36px;
}
.room-stopwatch-component[data-stopwatch-type="cash-item-01"] .stopwatch-cash-set-01[data-timer-type="1"] .shape-01 {
  display: block;
}
.room-stopwatch-component[data-stopwatch-type="cash-item-01"] .stopwatch-cash-set-01[data-timer-type="2"] .shape-02 {
  display: block;
}
.room-stopwatch-component[data-stopwatch-type="cash-item-01"] .stopwatch-cash-set-01[data-timer-type="3"] .shape-03 {
  display: block;
}
.room-stopwatch-component[data-stopwatch-type="cash-item-01"] .stopwatch-cash-set-01[data-timer-type="4"] .shape-04 {
  display: block;
}
.room-stopwatch-component[data-stopwatch-type="cash-item-01"] .stopwatch-cash-set-01[data-timer-type="5"] .shape-05 {
  display: block;
}
.room-stopwatch-component[data-stopwatch-type="cash-item-01"] .stopwatch-cash-set-01[data-timer-type="6"] .shape-06 {
  display: block;
}
.room-stopwatch-component:hover .stopwatch-control-btns {
  background-color: rgba(0, 0, 0, 0.6);
}
.room-stopwatch-component:hover .stopwatch-controls-pause {
  background-position-y: center;
}
.stopwatch-control-btns {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: auto;
  z-index: 2;
  transition: 200ms ease-out;
}
.stopwatch-controls-pause {
  width: 100%;
  height: 100%;
  background: url('~@/assets/images/camstudy/ico_pause_white.svg') center 50px no-repeat;
  background-size: auto 30%;
  font-size: 0;
  transition: 200ms ease-out;
}
.stopwatch-controls-reset {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
.stopwatch-controls-reset:hover .stopwatch-controls-reset-obj {
  background: white url('~@/assets/images/camstudy/ico_reload.svg') center no-repeat !important;
  background-size: auto 70% !important;
  transform: scale(1) rotate(-270deg) !important;
}
.stopwatch-controls-reset-obj {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  background: rgba(0, 0, 0, 0.3) url('~@/assets/images/camstudy/ico_reload_white.svg') center no-repeat;
  background-size: auto 70%;
  transition: 200ms ease-out;
  transform: scale(0);
}
.stopwatch-control-guide-tx {
  position: absolute;
  right: 8px;
  width: 100px;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.8);
  font-size: 12px;
  color: white;
  line-height: 19px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  display: none;
  user-select: none;
  pointer-events: none;
  backdrop-filter: blur(8px);
}
.stopwatch-control-guide-tx:after {
  content: '';
  position: absolute;
  top: -6px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid rgba(0, 0, 0, 0.8);
}
.room-stopwatch-component[data-stopwatch-state="pause"] {
  .room-stopwatch-component:before {
    background-color: #f05;
    animation: none;
  }
  
  .stopwatch-controls-pause {
    width: calc(100% - 36px);
    padding-left: 36px;
    background: url('~@/assets/images/camstudy/ico_arrowTriangleRight_white.svg') 12px center no-repeat;
    background-size: auto 30%;
    font-size: 12px;
    font-weight: bold;
    color: transparent;
    opacity: 0.9;
    transition: 100ms ease-out;
  }
  .stopwatch-controls-pause:hover {
    background-size: auto 36%;
    font-size: 14px;
    color: white;
    opacity: 1;
  }
  .stopwatch-controls-reset {
    display: flex;
    pointer-events: auto;
  }
  .stopwatch-controls-reset .stopwatch-controls-reset-obj {
    transform: scale(1);
  }
  [data-pomodoro-type="pomodoro_circle"] circle {
    stroke: rgba(255, 255, 255, 0.2);
  }
  [data-pomodoro-type="pomodoro_circle"] .stopwatch-controls-pause {
    width: 100%;
    padding: 0;
    background-position-x: center;
    background-size: auto 30%;
  }
  [data-pomodoro-type="pomodoro_circle"] .stopwatch-controls-pause:hover {
    padding-top: 30px;
    background-position-y: 20px;
    background-size: auto 24%;
  }
  [data-pomodoro-type="pomodoro_circle"] .stopwatch-controls-reset-obj {
    background: black url('~@/assets/images/camstudy/ico_reload_white.svg') center no-repeat;
    background-size: auto 70%;
  }
  [data-pomodoro-type="pomodoro_circle"] .stopwatch-controls-reset:hover .stopwatch-controls-reset-obj {
    transform: scale(1.2) rotate(-270deg) !important;
  }
  [data-pomodoro-type="pomodoro_mobile"] .stopwatch-controls-pause {
    width: calc(100% - 40px);
  }
  [data-stopwatch-type="cash-item-01"] .stopwatch-controls-pause {
    background-position-x: 16px;
  }
}
.room-stopwatch-component[data-my-video="true"] .stopwatch-control-btns {
  display: flex;
}
.room-stopwatch-component[data-my-video="true"] [data-pomodoro-type="pomodoro_circle"] .stopwatch-control-btns {
  border-radius: 100%;
}
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] .room-stopwatch-component:before {
  display: none;
}
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] .square-bg,
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] .circle-bg {
  background-color: rgba(255, 0, 85, 0.8);
}
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] .stopwatch-basic {
  padding: 0 34px 0 32px;
  font-size: 14px;
  color: white;
}
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] .stopwatch-basic:before {
  transform: scale(0);
}
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] [data-pomodoro-type="pomodoro_rect"] .square-bg {
  width: 180px;
}
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] [data-pomodoro-type="pomodoro_rect"] .pomodoro-time-tx {
  padding: 12px 36px 20px 32px;
}
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] [data-pomodoro-type="pomodoro_circle"] circle {
  stroke: rgba(255, 255, 255, 0.2);
}
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] [data-pomodoro-type="pomodoro_circle"] .pomodoro-time-tx {
  opacity: 0.3;
}
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] [data-pomodoro-type="pomodoro_mobile"] .progress-bar {
  background-color: rgba(255, 255, 255, 0.2);
}
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] [data-pomodoro-type="pomodoro_mobile"] .pomodoro-time-tx {
  padding: 0 40px 0 30px;
}
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] [data-stopwatch-type="cash-item-01"] .room-stopwatch-shape-bg.shape-01,
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] [data-stopwatch-type="cash-item-01"] .room-stopwatch-shape-bg.shape-03,
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] [data-stopwatch-type="cash-item-01"] .room-stopwatch-shape-bg.shape-04 {
  fill: rgba(255, 0, 85, 0.8);
}
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] [data-stopwatch-type="cash-item-01"] .room-stopwatch-shape-bg.shape-02,
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] [data-stopwatch-type="cash-item-01"] .room-stopwatch-shape-bg.shape-05,
.room-stopwatch-component[data-my-video="true"] [data-stopwatch-state="pause"] [data-stopwatch-type="cash-item-01"] .room-stopwatch-shape-bg.shape-06 {
  background-color: rgba(255, 0, 85, 0.8);
}
.room-stopwatch-component[data-stopwatch-state="relax"] .user-device-status {
  display: none;
}
.room-stopwatch-component[data-stopwatch-state="relax"] .room-stopwatch-component {
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
}
.room-stopwatch-component[data-stopwatch-state="relax"] .room-stopwatch-component:before {
  display: none;
}
.room-stopwatch-component[data-stopwatch-state="relax"] .user-sticker-layer {
  display: none;
}
.room-stopwatch-component:not([data-my-video="true"])[data-stopwatch-state="pause"] [data-pomodoro-type="pomodoro_circle"] circle {
  display: none;
}
.room-stopwatch-component:not([data-my-video="true"])[data-stopwatch-state="pause"] [data-pomodoro-type="pomodoro_circle"] .pomodoro-time-tx:after {
  transform: scale(1);
}
/** stopwatch option modal */
.stopwatch-modal-container {
  padding: 37px 0 24px 0;
}
.stopwatch-modal-container ul {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.stopwatch-modal-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 24px;
  gap: 5px;
}
.stopwatch-list-complete {
  position: absolute;
  left: 0;
  bottom: 0;
  border-radius: 6px;
  background: #51A9FE;
  width: 100%;
  height: 38px;
  color: #FFF;
  font-size: 16px;
  font-weight: 700;
}
.stopwatch-list-option {
  margin-bottom: 11px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 200px;
}
.stopwatch-list-option .stopwatch-list-ratio {
  background-repeat: no-repeat;
  background-size: cover;
  width: 15px;
  height: 15px;
}
.stopwatch-list-option .stopwatch-list-ratio:not(.stopwatch-list-option .stopwatch-list-ratio:checked) {
  //background-image: url("~@/assets/images/camstudy/room/stopwatch/stopwatch_pause_not_click.svg");
}
.stopwatch-list-option .stopwatch-list-ratio:checked {
  //background-image: url("~@/assets/images/camstudy/room/stopwatch/stopwatch_pause_click.svg");
}
.stopwatch-list-option-inner-container {
  box-sizing: border-box;
  border-radius: 10px;
  width: 100%;
  height: 43px;
  font-size: 11px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.stopwatch-list-option-inner-container[class*="click"] {
  background: #51A9FE;
  color: white;
}
.stopwatch-list-option-inner-container:not(.stopwatch-list-option-inner-container[class*="click"]) {
  background: #F4F7FA;
  color: black;
}
.stopwatch-option-input {
  box-sizing: border-box;
  width: 100%;
  height: 27px;
  margin-top: 6px;
  border: 0.6px solid #B3B3B3;
  border-radius: 5px;
  background: #FFF;
  padding: 0 15px;
  color: #B3B3B3;
  font-size: 11px;
}
.subject-none-message {
  color: #828282;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 15px;
}
.move-my-page {
  width: 164px;
  height: 31px;
  border-radius: 50px;
  border: 1px solid #51A9FE;
  background: #FFF;
  color: #51A9FE;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
}
.loading-image {
  width: 50px;
  height: 50px;
}
/*
.count-time
font-size: 15px;
.stopwatch-relax-wrapper
align-items: end;
flex-direction: row;
padding-top: 18px (edited)
.stopwatch-relax-time-tx
margin: 0 0 0 10px; (edited)
.stopwatch-relax-exit-btn
right: 0;
bottom: 0;
height: 32px;
padding: 0;
font-size: 12px; (edited)

 */
[data-video-size-level="0"] .count-time {
  font-size: 14px;
}
[data-video-size-level="0"] .stopwatch-relax-wrapper {
  align-items: end;
  flex-direction: row;
  padding-top: 18px;
}
[data-video-size-level="0"] .stopwatch-relax-time-tx {
  margin: 0 0 0 10px;
}
[data-video-size-level="0"] .stopwatch-relax-exit-btn {
  display: flex;
  right: 0;
  bottom: 0;
  width: 66px;
  height: 34px;
  align-items: center;
  border-radius: 0;
  padding: 0 10px;
  font-size: 12px;
}
[data-video-size-level="1"] .count-time {
  font-size: 14px;
}
[data-video-size-level="1"] .stopwatch-relax-wrapper {
  align-items: end;
  flex-direction: row;
  padding-top: 18px;
}
[data-video-size-level="1"] .stopwatch-relax-time-tx {
  margin: 0 0 0 10px;
}
[data-video-size-level="1"] .stopwatch-relax-exit-btn {
  display: flex;
  right: 0;
  bottom: 0;
  width: 66px;
  height: 34px;
  align-items: center;
  border-radius: 0;
  padding: 0 10px;
  font-size: 12px;
}
[data-video-size-level="2"] .count-time {
  font-size: 14px;
}
[data-video-size-level="2"] .stopwatch-relax-wrapper {
  align-items: end;
  flex-direction: row;
  padding-top: 18px;
}
[data-video-size-level="2"] .stopwatch-relax-time-tx {
  margin: 0 0 0 10px;
}
[data-video-size-level="2"] .stopwatch-relax-exit-btn {
  display: flex;
  right: 0;
  bottom: 0;
  width: 66px;
  height: 34px;
  align-items: center;
  border-radius: 0;
  padding: 0 10px;
  font-size: 12px;
}
[data-video-size-level="3"] .count-time {
  font-size: 14px;
}
[data-video-size-level="3"] .stopwatch-relax-wrapper {
  align-items: end;
  flex-direction: row;
  padding-top: 18px;
}
[data-video-size-level="3"] .stopwatch-relax-time-tx {
  margin: 0 0 0 10px;
}
[data-video-size-level="3"] .stopwatch-relax-exit-btn {
  display: flex;
  right: 0;
  bottom: 0;
  width: 66px;
  height: 34px;
  align-items: center;
  border-radius: 0;
  padding: 0 10px;
  font-size: 12px;
}
[data-video-size-level="4"] .count-time {
  font-size: 14px;
}
[data-video-size-level="4"] .stopwatch-relax-wrapper {
  align-items: end;
  flex-direction: row;
  padding-top: 18px;
}
[data-video-size-level="4"] .stopwatch-relax-time-tx {
  margin: 0 0 0 10px;
}
[data-video-size-level="4"] .stopwatch-relax-exit-btn {
  display: flex;
  right: 0;
  bottom: 0;
  width: 66px;
  height: 34px;
  align-items: center;
  border-radius: 0;
  padding: 0 10px;
  font-size: 12px;
}
.video-size-level-s-5 .count-time {
  font-size: 14px;
}
.video-size-level-s-5 .stopwatch-relax-wrapper {
  align-items: end;
  flex-direction: row;
  padding-top: 18px;
}
.video-size-level-s-5 .stopwatch-relax-time-tx {
  margin: 0 0 0 10px;
}
.video-size-level-s-5 .stopwatch-relax-exit-btn {
  display: flex;
  right: 0;
  bottom: 0;
  width: 66px;
  height: 34px;
  align-items: center;
  border-radius: 0;
  padding: 0 10px;
  font-size: 12px;
}
[data-pomodoro-type] .stopwatch-toast-enter-active {
  display: block;
  animation: stopwatch-control-guide-rect 4s ease-out backwards;
}
[data-pomodoro-type] .stopwatch-toast-leave-active {
  opacity: 0;
}
[data-pomodoro-type="pomodoro_circle"] .stopwatch-toast-enter-active {
  display: block;
  animation: stopwatch-control-guide-circle 4s ease-out backwards;
}
[data-pomodoro-type="pomodoro_circle"] .stopwatch-toast-leave-active {
  opacity: 0;
}
@keyframes opacity-infinite {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes stopwatch-control-guide-rect {
  0% {
    top: 32px;
    opacity: 0;
  }
  8% {
    top: 50px;
    opacity: 1;
  }
  92% {
    top: 50px;
    opacity: 1;
  }
  100% {
    top: 32px;
    opacity: 0;
  }
}
@keyframes stopwatch-control-guide-circle {
  0% {
    top: 60px;
    opacity: 0;
  }
  8% {
    top: 76px;
    opacity: 1;
  }
  92% {
    top: 76px;
    opacity: 1;
  }
  100% {
    top: 60px;
    opacity: 0;
  }
}
</style>